import styled from 'styled-components';
import Text from 'components/Text';

const H1 = styled(Text).attrs({
	as: 'h1'
})``;

H1.defaultProps = {
	fontSize: ['h1Small', 'h1'],
	fontWeight: 'bold',
	fontFamily: 'headlines',
	lineHeight: 1.16,
	mb: 4
};

export default H1;
